import React from 'react';
import PropTypes from 'prop-types';
import UILoader from '@sp/ui/base/Loader';
import withTranslation from 'decorators/i18n';

const Loader = ({ i18n, ...props }) => (
  <UILoader {...props} accessibilityLabel={i18n.t('Vent venligst. Indhold hentes.')} />
);

Loader.propTypes = {
  i18n: PropTypes.object.isRequired,
};

export default withTranslation()(Loader);
